import React, {
    Component,
    PropTypes
} from 'react';
import {
    Link,
} from "react-router";
import basicInfoService from 'SERVICES/purifier/basicInfoService'
import {ellaUrl, getMenuId} from 'CONFIG/path.config'
import userService from 'SERVICES/ella/userService'

const languages = navigator.languages;
const currentLang = languages == undefined ? navigator.language : languages[1];
import PasswordInput from 'CONFIG/component/form/passwordInput'
import {errorShow, errToSuc} from "./utils/common";

class App extends Component {
    constructor(props) {
        super(props);
        this.menuIdChange = this.menuIdChange;
        this.headerMenu = this.headerMenu.bind(this);
        this.menuText = this.menuText.bind(this);
        this.menuChildren = this.menuChildren;
        this.getMenuData = this.getMenuData.bind(this);
        this.state = {
            loginState: 'login_error',
            url: ellaUrl,
            userId: "",
            systems: [],
            menus: [],
            basicList: {},
        }
    }

    componentDidMount() {
        //侧边栏 ella 0 bump 1 dealer 2 mica
        sessionStorage.getItem('auth') == 'ok' ? this.setState({
            loginState: 'login_success',
            userId: sessionStorage.getItem('userId')
        }) : "";
        const userId = sessionStorage.getItem('userId');

        var menuId = "";
        if (sessionStorage.getItem('menuName')) {
            menuId = getMenuId(sessionStorage.getItem('menuName'))
        } else {
            menuId = 0;
            sessionStorage.setItem('menuName', 'ella');
        }
        this.getMenuData(menuId, userId);
    }

    menuIdChange(name, e) {
        sessionStorage.setItem('menuName', name);
        const menuId = getMenuId(name);
        const userId = sessionStorage.getItem('userId');
        $("li.active").removeClass("active");
        $(".treeview-menu").css("display","none");
        this.getMenuData(menuId, userId)
    }

    getMenuData(menuId, userId) {
        userService.getMenu(userId, menuId).then(data => {
            console.log(data);
            if (data.code == 8001) {
                const json = data.data;
                this.setState({
                    systems: json.systems,
                    menus: json.menus,
                })
                // if (sessionStorage.menuId) {
                //     $("#li_" + sessionStorage.menuId).addClass('active');
                //     $('#menu_' + sessionStorage.menuParentId).addClass('active');
                // }
            }

        })
    }

    logOut() {
        sessionStorage.clear();
        this.setState({
            loginState: 'login_error'
        })
    }

    headerMenu() {
        const _this = this;
        return this.state.systems.map(function (str, index) {
            return <li className="dropdown user user-menu " key={index}>
                <a href="#" className="dropdown-toggle" onClick={_this.menuIdChange.bind(_this, str.number)}>
                    <span>{str.name}</span>
                </a>
            </li>
        })
    }

    menuText() {
        const _this = this;

        return this.state.menus.map(function (str, index) {
            var name = str.name;
            if (currentLang == "en") {
                name = str.enName
            }
            return <li name="navLi" key={index} id={"menu_" + str.id}>
                <a>
                    <i className="fa fa-circle-thin"></i>
                    <span>{name}</span>
                    <span className="pull-right-container">
						<i className="fa fa-angle-left pull-right"></i>
					</span>
                </a>
                <ul className="treeview-menu" role="menu">
                    {_this.menuChildren(str.children, str.id)}
                </ul>
            </li>
        })
    }

    menuChildren(data, parentId) {
        const _this = this;
        if (data == null) {
            return;
        }
        return data.map(function (str, index) {
            var name = str.name;
            if (currentLang == "en") {
                name = str.enName
            }
            return <li key={index} id={'li_' + str.id}><Link to={str.url}
                                                             onClick={_this.getMenuId.bind(_this, str.id, parentId)}>{name}</Link>
            </li>
        })
    }

    getMenuId(id, parentId) {
        sessionStorage.setItem('menuParentId', parentId);
        $("#li_" + sessionStorage.menuId).removeClass('active');
        $("#li_" + id).addClass('active');
        sessionStorage.setItem('menuId', id);
    }

    basicInfo() {
        const id = this.state.userId;
        basicInfoService.meList(id).then(body => {
            const list = body.data;
            this.setState({
                basicList: list
            })
        })
    }

    submit(event) {
        event.preventDefault();
        errToSuc();
        const ids = ['beforePassword', 'newPassword', 'passwordAgain'];
        let arr = {};
        let errorMsg='';
        for (let i = 0; i < ids.length; i++) {
            let val = $.trim($("#" + ids[i]).val());
            if (val == '') {
                errorMsg = '信息未填写！';
                errorShow(ids[i], errorMsg);
            }
            arr[ids[i]] = val;
        }
        if (arr.newPassword != arr.passwordAgain && arr.newPassword != '' && arr.passwordAgain != '') {
            $("#msg_error").text("两次输入新密码不一致");
            $("#error_pass").removeClass("hidden");
            setTimeout(function () {
                $("#error_pass").addClass("hidden");
            }, 4000);
            errorMsg = '两次输入新密码不一致';
        }
        console.log(errorMsg)
        if (errorMsg == '') {
            const userName = sessionStorage.getItem('loginName');
            let data = {
                beforePassword: arr.beforePassword,
                newPassword: arr.newPassword,
                userName: userName
            };
            data = JSON.stringify(data);
            basicInfoService.updatePass({data}).then(body => {
                console.log(body)
                $("#success_pass").addClass("hidden");
                $("#error_pass").addClass("hidden");
                if (body.code == 8001) {
                    $("#msg_success").text(body.msg);
                    $("#success_pass").removeClass("hidden");
                    $("#success_pass").focus();
                    setTimeout(function () {
                        $("#success_pass").addClass("hidden");
                        $("#regionPass").modal('hide');
                    }, 3000);
                } else {
                    if (body.data != null) {
                        var errorList = body.data;
                        for (const i in errorList) {
                            const code = errorList[i].code;
                            $("#error_" + code).html(errorList[i].message || errorList[i].msg);
                            $("#error_" + code).attr("name", "error");
                            $("#error_" + code).parent().attr("class", "errmsgtop");
                            $("#error_" + code).siblings().attr("class", "triangle-down");
                            $("#" + code).focus();
                        }
                    } else {
                        $("#msg_error").text(body.msg);
                        $("#error_pass").removeClass("hidden");
                        $("#error_pass").focus();
                        setTimeout(function () {
                            $("#error_pass").addClass("hidden");
                        }, 4000);
                    }
                }
            })
        }
    }

    cancel(event) {
        event.preventDefault();
        $("#beforePassword").val("");
        $("#newPassword").val("");
        $("#passwordAgain").val("");
    }
    regionPass(){
        $("#beforePassword").val("");
        $("#newPassword").val("");
        $("#passwordAgain").val("");
        $("#regionPass").modal('show');
    }
    render() {
        return (
            <div>
                <div>
                    <div className="main-header">
                        <div className="navbar-header">
                            <Link to="/home" className="logo">
                                <span className="logo-mini">
                                    <img src="../css/images/logo_3.png"
                                         style={{
                                             paddingTop: "15px",
                                             paddingBottom: "10px",
                                             height:'55px'
                                         }}/>
                                </span>
                                <span className="logo-lg"><img src="../css/images/logo_1.png" style={{
                                    width: "140px",
                                    paddingBottom: "5px",
                                    paddingTop: "5px"
                                }}/></span>
                            </Link>
                        </div>
                        <div id="navbar-menu" className="navbar navbar-static-top">
                            <a href="#" className="sidebar-toggle" data-toggle="offcanvas" role="button">
                                <span className="sr-only"></span>
                            </a>
                            <ul className="nav navbar-nav">
                                {this.headerMenu()}
                            </ul>
                            <div className="navbar-custom-menu">
                                <ul className="nav navbar-nav">
                                    <li className="dropdown user user-menu ">
                                        <a href="#" className="dropdown-toggle" data-toggle="dropdown"
                                           style={{paddingRight: "30px"}}>
                                            <img src="../../../css/images/user.jpg" className="user-image"
                                                 alt="User Image"/>
                                            <span className="hidden-xs">{sessionStorage.loginName}</span>
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><a onClick={this.regionPass.bind(this)}>修改密码</a></li>
                                            <li><a href="" onClick={this.logOut.bind(this)}>退出</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/*侧栏*/}
                    <div className="main-sidebar">
                        <section className="sidebar">
                            <ul className="sidebar-menu" style={{paddingTop: "15px"}}>
                                {this.menuText()}
                            </ul>
                        </section>
                    </div>
                    <div className="content-wrapper" style={{minHeight: "800px"}}>
                        {this.props.children}
                    </div>
                    <footer className="main-footer">
                        版权所有 &copy; 2016-2017 杭州贤芯科技有限公司
                    </footer>
                </div>
                <div className="modal fade" id={'regionPass'} tabIndex="-1" role="dialog"
                     aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close"
                                        data-dismiss="modal" aria-hidden="true">
                                    &times;
                                </button>
                                <h4 className="modal-title">
                                    <strong>修改密码</strong>
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div id={"error_pass"} className="hidden alert-tip">
                                    <div className="alert alert-danger">
                                        <strong>错误！</strong>
                                        <button type="button" className="close" data-dismiss='alert'>×</button>
                                        <span id={"msg_error"}>操作失败.</span>
                                    </div>
                                </div>
                                <div id={"success_pass"} className="hidden alert-tip">
                                    <div className="alert alert-success">
                                        <strong>成功！</strong>
                                        <button type="button" className="close" data-dismiss='alert'>×</button>
                                        <span id={"msg_success"}>操作成功.</span>
                                    </div>
                                </div>
                                <form>
                                    <PasswordInput id="beforePassword" name="oldPass"/>
                                    <PasswordInput id="newPassword" name="newPass"/>
                                    <PasswordInput id="passwordAgain" name="passAgain"/>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-dropbox" onClick={this.submit.bind(this)}>提交</button>
                                <div className="col-xs-1 text-center">
                                    <button type="button" className="btn btn-default"
                                            data-dismiss="modal" onClick={this.cancel.bind(this)}>取消
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default App;



















// WEBPACK FOOTER //
// ./modules/App.js